
(() => {
  if (window.Shopify && Shopify.designMode) document.documentElement.classList.add("nx-design-mode");
  const ensureHomeClickStyles = () => {
    if (document.getElementById("neox-home-primary-click-targets-js")) return;
    const style = document.createElement("style");
    style.id = "neox-home-primary-click-targets-js";
    style.textContent = `
      .nx-hero__hitlink,.nx-featured__hitlink{position:absolute;inset:0;z-index:1;display:block;cursor:pointer}
      .nx-hero__copy,.nx-featured__copy{pointer-events:none}
      .nx-hero__copy a,.nx-featured__copy a{pointer-events:auto}
      .nx-featured{position:relative}
      .nx-featured__copy{position:relative;z-index:2}
      .nx-hero__media{pointer-events:none}
    `;
    document.head.appendChild(style);
  };
  ensureHomeClickStyles();

  document.querySelectorAll(".nx-nav__item").forEach((item) => {
    let closeTimer;
    item.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
      document.querySelectorAll(".nx-nav__item.is-open").forEach((openItem) => {
        if (openItem !== item) openItem.classList.remove("is-open");
      });
      item.classList.add("is-open");
    });
    item.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(() => item.classList.remove("is-open"), 120);
    });
  });


  const initHero = (hero) => {
    if (hero.dataset.nxHeroInitialized === "true") return;
    hero.dataset.nxHeroInitialized = "true";
    const allSlides = [...hero.querySelectorAll("[data-nx-slide]")];
    const allButtons = [...hero.querySelectorAll("[data-nx-target]")];
    let active = 0;
    let timer;
    const isMobile = () => window.matchMedia("(max-width: 720px)").matches;
    const isVisibleOnCurrentViewport = (item) => !(isMobile() && item.dataset.nxMobileHidden === "true");
    const currentSlides = () => allSlides.filter(isVisibleOnCurrentViewport);
    const currentButtons = () => allButtons.filter(isVisibleOnCurrentViewport);
    const syncHeroNaturalSize = (slide) => {
      if (!slide) return;
      ["--nx-pc-image-width", "--nx-pc-image-height", "--nx-pc-image-ratio"].forEach((name) => {
        const value = slide.style.getPropertyValue(name);
        if (value) hero.style.setProperty(name, value.trim());
      });
    };
    const hardHideSlide = (slide) => {
      slide.classList.remove("is-active", "is-mobile-active");
      slide.setAttribute("aria-hidden", "true");
      slide.style.display = "none";
      slide.style.opacity = "0";
      slide.style.visibility = "hidden";
      slide.style.pointerEvents = "none";
    };
    const hardShowSlide = (slide) => {
      slide.classList.add("is-active", "is-mobile-active");
      slide.setAttribute("aria-hidden", "false");
      slide.style.display = isMobile() ? "block" : "";
      slide.style.opacity = "1";
      slide.style.visibility = "visible";
      slide.style.pointerEvents = "auto";
    };
    const setSlide = (index) => {
      const slides = currentSlides();
      const buttons = currentButtons();
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      syncHeroNaturalSize(slides[active]);
      allSlides.forEach((slide) => {
        const slideActive = slide === slides[active];
        if (slideActive) hardShowSlide(slide);
        else hardHideSlide(slide);
      });
      allButtons.forEach((button) => {
        const hidden = !isVisibleOnCurrentViewport(button);
        const buttonActive = !hidden && button === buttons[active];
        button.hidden = hidden;
        button.classList.toggle("is-active", buttonActive);
        if (buttonActive) {
          button.style.animation = "none";
          button.offsetHeight;
          button.style.animation = "";
          button.style.setProperty("--nx-progress-running", "running");
        } else {
          button.style.animation = "none";
          button.style.setProperty("--nx-progress-running", "paused");
        }
      });
    };
    const start = () => {
      clearInterval(timer);
      timer = setInterval(() => setSlide(active + 1), isMobile() ? 3800 : 3000);
    };
    const ensureSlideLinks = () => {
      allSlides.forEach((slide) => {
        const primary = slide.querySelector(".nx-actions .nx-btn--dark[href]");
        if (!primary) return;
        let hitlink = slide.querySelector(".nx-hero__hitlink");
        if (!hitlink) {
          hitlink = document.createElement("a");
          hitlink.className = "nx-hero__hitlink";
          slide.insertBefore(hitlink, slide.firstChild);
        }
        hitlink.href = primary.href;
        hitlink.target = primary.target || "_blank";
        hitlink.rel = primary.rel || "noopener noreferrer";
        hitlink.setAttribute("aria-label", primary.textContent.trim() || "View product");
      });
    };
    ensureSlideLinks();
    allButtons.forEach((button) => button.addEventListener("click", () => {
      const buttons = currentButtons();
      setSlide(buttons.indexOf(button));
      start();
    }));
    let swipeStartX = 0;
    let swipeStartY = 0;
    let swipePointer = null;
    let didSwipe = false;
    hero.addEventListener("pointerdown", (event) => {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      swipePointer = event.pointerId;
      swipeStartX = event.clientX;
      swipeStartY = event.clientY;
      didSwipe = false;
    }, { capture: true, passive: true });
    hero.addEventListener("pointerup", (event) => {
      if (swipePointer !== event.pointerId) return;
      const dx = event.clientX - swipeStartX;
      const dy = event.clientY - swipeStartY;
      swipePointer = null;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
      didSwipe = true;
      setSlide(active + (dx < 0 ? 1 : -1));
      start();
    }, { capture: true, passive: true });
    hero.addEventListener("pointercancel", () => {
      swipePointer = null;
    }, { passive: true });
    hero.addEventListener("click", (event) => {
      if (!didSwipe || !event.target.closest(".nx-hero__hitlink")) return;
      event.preventDefault();
      event.stopPropagation();
      didSwipe = false;
    }, true);
    window.addEventListener("resize", () => setSlide(0), { passive: true });
    hero.addEventListener("mouseenter", () => clearInterval(timer));
    hero.addEventListener("mouseleave", start);
    setSlide(0);
    start();
  };

  document.querySelectorAll("[data-nx-hero]").forEach(initHero);
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-nx-hero]").forEach(initHero);
  });
  document.addEventListener("shopify:block:select", (event) => {
    const slide = event.target.closest("[data-nx-slide]");
    const hero = slide && slide.closest("[data-nx-hero]");
    if (!slide || !hero) return;
    ["--nx-pc-image-width", "--nx-pc-image-height", "--nx-pc-image-ratio"].forEach((name) => {
      const value = slide.style.getPropertyValue(name);
      if (value) hero.style.setProperty(name, value.trim());
    });
    hero.querySelectorAll("[data-nx-slide]").forEach((item) => item.classList.toggle("is-active", item === slide));
    hero.querySelectorAll("[data-nx-target]").forEach((button) => button.classList.toggle("is-active", Number(button.dataset.nxTarget) === [...hero.querySelectorAll("[data-nx-slide]")].indexOf(slide)));
  });

  document.querySelectorAll("[data-nx-categories]").forEach((section) => {
    const tabs = [...section.querySelectorAll("[data-nx-category-tab]")];
    const panels = [...section.querySelectorAll("[data-nx-category-panel]")];
    const activate = (id) => {
      if (!id) return;
      const target = tabs.find((tab) => tab.dataset.nxCategoryTab === id);
      if (!target) return;
      tabs.forEach((item) => item.classList.toggle("is-active", item === target));
      panels.forEach((panel) => panel.classList.toggle("is-active", panel.dataset.nxCategoryPanel === id));
    };
    tabs.forEach((tab) => tab.addEventListener("click", () => {
      const id = tab.dataset.nxCategoryTab;
      activate(id);
    }));
    const ensureFeaturedLinks = () => {
      panels.forEach((panel) => {
        const featured = panel.querySelector(".nx-featured");
        const primary = featured && featured.querySelector(".nx-featured__copy .nx-btn--dark[href]");
        if (!featured || !primary) return;
        let hitlink = featured.querySelector(".nx-featured__hitlink");
        if (!hitlink) {
          hitlink = document.createElement("a");
          hitlink.className = "nx-featured__hitlink";
          featured.insertBefore(hitlink, featured.firstChild);
        }
        hitlink.href = primary.href;
        hitlink.target = primary.target || "_blank";
        hitlink.rel = primary.rel || "noopener noreferrer";
        hitlink.setAttribute("aria-label", primary.textContent.trim() || "View products");
      });
    };
    const activeIndex = () => Math.max(0, tabs.findIndex((tab) => tab.classList.contains("is-active")));
    const activateByOffset = (offset) => {
      if (!tabs.length) return;
      const next = (activeIndex() + offset + tabs.length) % tabs.length;
      activate(tabs[next].dataset.nxCategoryTab);
    };
    const swipeTargets = [section.querySelector(".nx-product-board"), ...section.querySelectorAll(".nx-featured")].filter(Boolean);
    let categoryStartX = 0;
    let categoryStartY = 0;
    let categoryPointer = null;
    let categorySwiped = false;
    swipeTargets.forEach((target) => {
      target.addEventListener("pointerdown", (event) => {
        if (event.pointerType === "mouse" && event.button !== 0) return;
        categoryPointer = event.pointerId;
        categoryStartX = event.clientX;
        categoryStartY = event.clientY;
        categorySwiped = false;
      }, { capture: true, passive: true });
      target.addEventListener("pointerup", (event) => {
        if (categoryPointer !== event.pointerId) return;
        const dx = event.clientX - categoryStartX;
        const dy = event.clientY - categoryStartY;
        categoryPointer = null;
        if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
        categorySwiped = true;
        activateByOffset(dx < 0 ? 1 : -1);
      }, { capture: true, passive: true });
      target.addEventListener("pointercancel", () => {
        categoryPointer = null;
      }, { passive: true });
      target.addEventListener("click", (event) => {
        if (!categorySwiped || !event.target.closest(".nx-featured__hitlink")) return;
        event.preventDefault();
        event.stopPropagation();
        categorySwiped = false;
      }, true);
    });
    ensureFeaturedLinks();
    const activateFromHash = () => {
      const match = window.location.hash.match(/^#products-([a-z0-9_-]+)$/);
      if (match) activate(match[1]);
    };
    activateFromHash();
    window.addEventListener("hashchange", activateFromHash);
  });

})();
